/**
 * Everything here is deprecated for use in the new code.
 * These types were moved up from @softr/definitions package
 * because they were imported in many places across the codebase.
 */
import { ColorPaletteType, DataSourceType } from "./types";

export interface Attachment {
    id?: string;
    url: string;
    filename?: string;
    handle?: string;
    file?: Attachment; //for SmartSuite Case
    type?: string;
    metadata?: {
        filename: string;
        mimetype: string;
    };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface FormButtonType {
    className: string;
    label: string;
    action: {
        applicationId: string;
        options: EmailCaptureAction;
    };
    styles: { [key: string]: string };
}

export interface FormRecaptcha {
    enabled: boolean;
    type: string;
}

export interface FormField {
    name?: string;
    format?: string;
    mappedTo?: string;
    fieldName?: string;
    label:
        | string
        | {
              className: string;
              styles: Record<string, string | number>;
              tag: string;
              value: string;
          };
    className: string;
    enabled?: boolean;
    isRequired: boolean;
    type: FormFieldType;
    placeholder: string;
    value?: string | string[];
    values?: string | string[];
    styles: { [key: string]: string };
    isLinkedForm?: boolean;
    syncWithDataSource?: boolean;
    multiSelect?: boolean;
    optionsOrder?: SortOrderEnum;
    multiRecordsLink?: boolean;
}

export enum SortOrderEnum {
    ASC = "ASC",
    DESC = "DESC",
    CUSTOM = "CUSTOM",
    AS_DEFINED_IN_SOURCE = "AS_DEFINED_IN_SOURCE",
}

export enum FormFieldType {
    Url = "url",
    Date = "date",
    File = "file",
    Image = "image",
    Text = "text",
    Email = "email",
    Hidden = "hidden",
    Rating = "rating",
    Address = "address",
    Checkbox = "checkbox",
    Password = "password",
    Dropdown = "dropdown",
    AutoSyncDropdown = "auto_sync_dropdown",
    DateTime = "dateTime",
    LongText = "long_text",
    ShortText = "short_text",
    PhoneNumber = "phone_number",
    MultiSelect = "multi_select",
    Signature = "signature",
    Number = "number",
}

export type FormFile = { name?: string; url: string };

export type FormValues = {
    [key: string]: string | string[] | FormFile[] | Record<string, string>;
};

export interface DynamicElements {
    type: string;
    enabled?: boolean;
    items: FormField[];
}

export enum BlockCategory {
    Header = "Header",
    Hero = "Hero",
    FAQ = "FAQ",
    Chart = "Chart",
    CustomCode = "Custom Code",
    ItemDetails = "Item Details",
    List = "List",
    Other = "Other",
    Footer = "Footer",
    Form = "Form",
    OrganizationalChart = "Organizational Chart",
    Payment = "Payment",
}

export enum BlockType {
    Static = "static",
    Dynamic = "dynamic",
}

export enum BlockPermissionType {
    View = "VIEW",
    Edit = "EDIT",
}

export enum Position {
    Left = "LEFT",
    Right = "RIGHT",
    Center = "CENTER",
    Top = "TOP",
    Bottom = "BOTTOM",
}

export enum BlockPermissionUserGroup {
    AllUsers = "ALL_USERS",
}

export enum BlockElementGroupType {
    Array = "array",
}

export enum BlockDataSourceType {
    Airtable = "AIRTABLE_LEGACY",
    Gsheet = "GOOGLE_SHEET",
    Softr = "SOFTR",
}

export type BlockTag =
    | "nav"
    | "img"
    | "a"
    | "i"
    | "h1"
    | "header"
    | "p"
    | "div"
    | "h6"
    | "section"
    | "h2"
    | "h4"
    | "iframe"
    | "input"
    | "footer"
    | "hr"
    | "small";

export type BlockElmentType = ElementTypes;

export type BlockElementActionType = "navigate" | "request";

export type BlockElementIconProvider = "font-awesome";

export type BlockPermissionGroup = {
    custom_user_group_ids: any[]; ///todo
    predefined_user_group_type: BlockPermissionUserGroup | null;
};

export type BlockPermission = {
    [BlockPermissionType.View]: BlockPermissionGroup;
    [BlockPermissionType.Edit]: BlockPermissionGroup;
};

export type BlockStyle = {
    classes: string[];
    label: string;
    name: string;
    isPrimary?: boolean;
    showFor?: string;
};

export type BlockElement = {
    type?: BlockElmentType;
    tag?: BlockTag;
    primaryStyles?: BlockStyle[];
    otherStyles?: BlockStyle[];
    src?: string;
};

export type BlockElements = { [key: string]: BlockElement };

export type BlockElementBase = {
    type?: BlockElmentType;
    tag?: BlockTag;
    primaryStyles?: BlockStyle[];
    otherStyles?: BlockStyle[];
    className?: string;
    styles: Record<string, any>;
    src?: string;
};

export type BlockElementTypewriter = {
    tag?: BlockTag;
    primaryStyles?: BlockStyle[];
    backSpeed: number;
    typeSpeed: number;
    value: string;
};

export type BlockElementToggle = {
    enabled: boolean;
};

export type BlockElementOther = {
    id: string;
    mappedTo: string;
    deletable: boolean;
    enabled: boolean;
    label?: string;
    value: string | string[];
};

export type BlockElementActionOption = {
    value?: string;
    url?: any;
};

export type BlockElementAction = {
    type: BlockElementActionType;
    options: any;
    // options: BlockElementActionOption & {
    //   [key: string]: BlockElementActionOption;
    // }
    applicationId?: string;
    action?: string;
};

export type BlockMessage = {
    value: string;
    primaryStyles: BlockStyle[];
};

export enum SuccessAction {
    ShowMessage = "SHOW_MESSAGE",
    Action = "ACTION",
    NoAction = "NO_ACTION",
    OpenPage = "OPEN_PAGE",
}

export type BlockElementSuccessAction = {
    externalUrl: string;
    selectedState: SuccessAction;
    path: string; //"NO_ACTION",
    message: BlockMessage;
};

export type BlockElementText = BlockElementBase & {
    value: string;
    htmlTag: string;
    label?: string;
};

export type BlockElementTitle = BlockElementBase & {
    label: string;
};

export type BlockElementInput = BlockElementBase & {
    format: string;
    placeholder: string;
    enabled: boolean;
};

export type BlockElementImage = BlockElementBase & {
    src: string;
    alt?: string;
    value?: string;
};

export type BlockElementVideo = BlockElementBase & {
    src: string;
    value?: string;
};

export type BlockElementTag = BlockElementBase & {
    alt: string;
    value: string;
};

export type BlockElementLink = BlockElementBase & {
    value: string;
    action: BlockElementAction;
    className: string;
    styles: Record<string, any>;
};

export type BlockElementSocial = BlockElementBase & {
    value: string;
    url: string;
};

export type BlockElementLinkGroup = {
    links: BlockElementGroup<BlockElementLink>;
    title: BlockElementText;
};

export type BlockElementFile = BlockElementLink & {
    alt: string;
};

export type BlockElementButton = BlockElementBase & {
    value: string;
    label: string;
    action: BlockElementAction;
};

export type BlockElementLinkUrl = {
    destination: string;
    target: string;
};

export type BlockElementFormToggle = {
    label: string;
    tag: string;
    type: string;
    primaryStyles: BlockStyle[];
    otherStyles: BlockStyle[];
    enabled: boolean;
};

export type BlockElementFormButton = BlockElementButton & {
    label: string;
    enabled?: boolean;
    action?: {
        type: "navigate";
        options: {
            url: BlockElementLinkUrl;
        };
    };
};

export type BlockElementInfoLink = {
    label: string;
    primaryStyles?: BlockStyle[];
    otherStyles?: BlockStyle[];
    enabled?: boolean;
    action?: {
        type: "navigate";
        options: {
            url: BlockElementLinkUrl;
        };
    };
};

export type BlockElementFormElement = BlockElementBase & {
    isRequired: boolean;
    placeholder: string;
    deletable: boolean;
    values: string;
    label: string;
    name: string;
    value?: string;
};

export type BlockElementInputToggleLink = BlockElementBase & {
    enabled: boolean;
    value: string;
    placeholder: string;
};

export type BlockElementSocialLink = BlockElementBase & {
    label: string;
    action: BlockElementAction;
    icon: string;
};

export type BlockElementDecoratedLink = BlockElementBase & {
    link: BlockElementLink;
    icon: BlockElementIcon;
    description: BlockElementText;
};

export type BlockElementIcon = BlockElementBase & {
    provider?: BlockElementIconProvider;
    value: string;
    src: string;
    className: string;
    styles: Record<string, any>;
};

export type BlockElementDecoratedGroupLink = {
    link: BlockElementLink;
    subLinks: BlockElementGroup<BlockElementDecoratedLink>;
};

export type BlockElementGroupLinkWithSubs = {
    link: BlockElementLink;
    subLinks: BlockElementGroup<BlockElementLink>;
};

export type BlockElementGroupLink = {
    link: BlockElementLink;
};

export type BlockElementProfileLink = {
    link: BlockElementLink;
    icon: BlockElementIcon;
};

export type BlockElementGroup<T> = {
    type: BlockElementGroupType;
    item_type: string;
    items: T[];
    minItems?: number;
    maxItems?: number;
    src?: string;
};

export type BlockElementFormInput = {
    type:
        | "address"
        | "rating"
        | "url"
        | "short_text"
        | "email"
        | "phone_number"
        | "dropdown"
        | "long_text"
        | "multi_select"
        | "date"
        | "dateTime"
        | "checkbox"
        | "hidden"
        | "file";
    placeholder: string;
    enabled: boolean;
    format: string;
    tag: "input";
    primaryStyles?: BlockStyle[];
    otherStyles?: BlockStyle[];
};

export type FormEmailCapture = {
    type: "email_capture";
    emailInput: BlockElementFormInput;
    button: BlockElementButton;
    success_action: BlockElementSuccessAction;
};

export type FormItem = {
    type:
        | "address"
        | "rating"
        | "url"
        | "short_text"
        | "email"
        | "phone_number"
        | "dropdown"
        | "long_text"
        | "multi_select"
        | "date"
        | "dateTime"
        | "checkbox"
        | "hidden"
        | "file";
    placeholder: string;
    label?: string;
    name?: string;
    primaryStyles?: BlockStyle[];
    otherStyles?: BlockStyle[];
    isRequired?: boolean;
    enabled?: boolean;
    deletable?: boolean;
    hasToggle?: boolean;
    mappedTo?: string;
    values?: string;
    value?: string;
};

export type BlockElementFormElements = {
    item_type: string;
    type: string;
    enabled?: boolean;
    items: FormItem[];
};

export type BlockElementForm = {
    type: string;
    elements: BlockElementFormElements;
    button: BlockElementButton;
    reCaptcha: {
        enabled: boolean;
        type: string;
    };
};

export type BlockUpdated = {
    date: string;
    version: string;
};

export type BlockDataSource = {
    type: BlockDataSourceType;
    [BlockDataSourceType.Airtable]: {
        url: string;
        baseId: string;
        tableName: string;
        viewName: string;
    };
    [BlockDataSourceType.Softr]: {
        applicationId: string;
        collectionId: string;
    };
    [BlockDataSourceType.Gsheet]: any;
};

export type BaseBlock<E, C = undefined> = {
    id: string;
    hrid: string;
    version: string;
    enabled?: boolean;
    is_enabled?: boolean;
    name: string;
    title: string;
    image: string;
    keywords: string;
    category: BlockCategory;
    type: BlockType;
    elements: E;
    collection: C;
    permissions: BlockPermission;
    updated: BlockUpdated[];
    defaultTheme: Record<string, any>;
};

export type BlockElementFieldDefinition<T> = {
    label: { ["$ref"]: string };
    field: T & BlockElementOther;
};

export type BlockElementField<T> = {
    label: BlockElementText;
    field: T & BlockElementOther & BlockElementFormButton;
};

export type BlockElementUnion = BlockElementField<
    BlockElementBase | BlockElementText | BlockElementTag | BlockElementImage | BlockElementButton
>;

export interface Text {
    tag: string;
    type?: string;
    primaryStyles: Style[];
    otherStyles?: Style[];
    value: string;
}

export interface Style {
    classes: string[];
    isPrimary: boolean;
    label: string;
    name: string;
    showFor?: "icon" | "image";
}

export interface Container {
    tag: string;
    type: string;
    primaryStyles: Style[];
    otherStyles?: Style[];
    value?: string;
    label?: string;
}

export interface BGImage {
    tag: string;
    primaryStyles: Style[];
    otherStyles: Style[];
    src: string;
    type?: string;
}

export interface Icon {
    provider: string;
    src: string;
    tag: string;
    type: string;
    value: string;
    primaryStyles: Style[];
    otherStyles: Style[];
}

export interface Image extends BGImage {
    alt: string;
}

export interface Action {
    action?: string;
    options: {
        url: {
            destination: string;
            target: string;
        };
        modalOptions?: {
            modalSize: string;
        };
    };
    type?: string;
}

export interface Button<T = Action> {
    action: T;
    label: string;
    otherStyles: Style[];
    primaryStyles: Style[];
    tag: string;
    type: string;
    value?: string;
}

export enum MailServices {
    Integromat = "integromatWebhook",
    Mailchimp = "mailchimp",
    Mailerlite = "mailerlite",
    Zapier = "zapierWebhook",
    AirtableBase = "airtableBase",
    Airtable = "AIRTABLE",
    GoogleSheet = "GOOGLE_SHEET",
    SmartSuite = "SMARTSUITE",
    Hubspot = "HUBSPOT",
    Email = "email",
}

export interface EmailCaptureAction {
    action?: string;
    options: {
        [MailServices.Integromat]: { url: string };
        [MailServices.Mailchimp]: { url: string };
        [MailServices.Mailerlite]: { url: string };
        [MailServices.Zapier]: { url: string };
        [MailServices.AirtableBase]: { url: string };
        [MailServices.Email]: { value: string };
    };
    type: string;
}

export type EmailCaptureButton = Button<EmailCaptureAction>;

export interface SocialLink {
    otherStyles: Style[];
    primaryStyles: Style[];
    type?: string;
    tag: string;
    value: string;
    url: string;
}

export interface Link extends Omit<SocialLink, "url"> {
    action?: Action;
    state?: boolean; // TODO Armen (state property is custom and added only on header sub links)
}

export interface EmailInput {
    label?: string;
    tag: string;
    type: string;
    format: string;
    primaryStyles: Style[];
    otherStyles: Style[];
    placeholder: string;
    value?: string;
}

export interface EmailCaptureSuccessAction {
    selectedState: string;
    path: string;
    message: {
        primaryStyles: Style[];
        value: string;
    };
}

export interface ItemContainer<T> {
    item_type: string;
    items: T[];
    type: string;
    maxItems?: number;
    minItems?: number;
}

export interface InlineFilter {
    allLabel: {
        otherStyles: Style[];
        primaryStyles: Style[];
        tag: string;
        value: string;
    };
    container: {
        otherStyles: Style[];
        primaryStyles: Style[];
        tag: string;
    };
    label: {
        otherStyles: Style[];
        primaryStyles: Style[];
        tag: string;
        value: string;
        className: string;
        styles: object;
    };
    mappedTo: string;
    multiselect: boolean;
    options: ListBlockFilterItemOption;
    positions: string[];
    selectedPosition: "LEFT" | "RIGHT" | "TOP";
    selectedShowAs: "List" | "Dropdown";
    showAll: boolean;
    showAs: string[];
    values: string | string[];
}

export interface InlineFilter {
    className: string;
    styles: Record<string, any>;
    mappedTo: string;
    multiselect: boolean;
    syncWithDatasource?: boolean;
    sort?: SortOrderEnum;
    tagPerLine?: boolean;
    colorPalette: ColorPaletteType;
    condition?: {
        enabled: false;
        logicalOperator: "AND";
        expressions: [];
    };
}

export interface SearchInput {
    tag: string;
    type: string;
    format: string;
    enabled: boolean;
    placeholder: string;
    otherStyles: Style[];
    primaryStyles: Style[];
}

export interface ConditionalFilter {
    subject: { field: string; type: string };
    operator: string;
    value: string[];
}

export enum NoMatchStrategy {
    HIDE = "HIDE",
    EMPTY_STATE = "EMPTY_STATE",
}

export interface DataSource<T = DatasourceAirtable> {
    airtable?: T;
    softr?: {
        applicationId: string;
        collectionId: string;
    };
    id?: string;
    isComplete?: boolean;
    type: string;
    isLinkedList?: boolean;
    isLinkedDetails?: boolean;
}

export interface DatasourceAirtable {
    url: string;
    baseId: string;
    tableName: string;
    viewName: string;
}

export interface EmptyStateMessage {
    tag: string;
    value: string;
    primaryStyles: Style[];
}

export interface ElFields {
    collectionItem?: {
        container: {
            otherStyles: Style[];
            primaryStyles: Style[];
            tag: string;
        };
    }[];
    items: ListBlockFieldItem[];
    staticFieldsCount: number;
}

export interface LoadMoreButton {
    field: ListBlockFieldItemField;
    label: string;
    otherStyles: Style[];
    primaryStyles: Style[];
}

/* Definition Start */

export interface ListBlockFieldItem {
    // TODO this interface do not cover all definition properties (Armen find better way)
    field: ListBlockFieldItemField;
    label?: {
        className: string;
        styles: Record<string, string>;
        value: string;
    }; // NOTE not required?
}

export interface ListBlockFieldItemField {
    id?: string;
    alt?: string;
    tag?: string;
    htmlTag?: string;
    type: string;
    value?: string;
    label?: string;

    action?: Action;

    mappedTo: string;
    colorPalette: ColorPaletteType;
    enabled: boolean;
    deletable: boolean;
    className: string;
    styles: object;
    hasToggle?: boolean;
    tableLabel?: string;
}

export interface ListBlockFilterItemOption {
    otherStyles: Style[];
    primaryStyles: Style[];
    tag: string;
    value: string;
}

export interface ElInlineFilter {
    allLabel: {
        className: string;
        styles: object;
        tag: string;
        value: string;
    };
    container: {
        className: string;
        styles: object;
        tag: string;
    };
    label: {
        className: string;
        styles: object;
        tag: string;
        value: string;
    };
    options: {
        className: string;
        styles: object;
        tag: string;
        value: string;
    };
    mappedTo: string;
    colorPalette: ColorPaletteType;
    multiselect: boolean;
    syncWithDatasource?: boolean;
    sort?: SortOrderEnum;
    tagPerLine: boolean;
    positions: string[];
    selectedPosition: "LEFT" | "RIGHT" | "TOP";
    selectedShowAs: "List" | "Dropdown";
    showAll: boolean;
    showAs: string[];
    values: string;
    condition: {
        enabled: false;
        logicalOperator: "AND";
        expressions: [];
    };
}

export interface ElInlineFilters {
    item_type: string;
    items: ElInlineFilter[];
    type: string;
    maxItems?: number;
    minItems?: number;
}

/* Definition End */

export type BlockElementGallery = BlockElementBase & {
    value: string[];
};

export type BlockElementAudio = BlockElementBase & {
    value: string;
};

export type BlockElementGroupIcon = {
    link: BlockElementLink;
    icon: BlockElementIcon;
};

export enum ElementTypes {
    PASSWORD = "password",
    ADDRESS = "address",
    RATING = "rating",
    HEADING1 = "heading1",
    HEADING2 = "heading2",
    HEADING3 = "heading3",
    BUTTON = "button",
    URL = "url",
    TAG = "tag",
    SHORT_TEXT = "short_text",
    EMAIL = "email",
    PHONE_NUMBER = "phone_number",
    DIVIDER = "divider",
    DROPDOWN = "dropdown",
    LONG_TEXT = "long_text",
    MULTI_SELECT = "multi_select",
    STATIC_IMAGE = "staticImage",
    IMAGE = "image",
    DATE = "date",
    DATETIME = "dateTime",
    CHECKBOX = "checkbox",
    HIDDEN = "hidden",
    FILE = "file",
    TEXT = "text",
    RICH_TEXT = "rich_text",
    UPVOTE_BUTTON = "upvoteButton",
    GMAPS = "gmaps",
    EMBED = "embed",
    AUDIO = "audio",
    VIDEO = "video",
    GALLERY = "gallery",
    IMAGE_OR_VIDEO = "imageOrVideo",
    PDF = "pdf",
}

export enum TextTypes {
    "heading1" = "h1",
    "heading2" = "h2",
    "heading3" = "h3",
    "heading4" = "h4",
    "heading5" = "h5",
    "heading6" = "h6",
    "text" = "p",
}

type UrlType = {
    destination: string;
    target: string;
};

export type FieldItem = {
    id: string;
    tag: string;
    type: ElementTypes;
    placeholder?: string;
    label?: string;
    fieldLabel?: BlockElementText;
    name?: string;
    primaryStyles?: BlockStyle[];
    otherStyles?: BlockStyle[];
    className?: string;
    isRequired?: boolean;
    enabled?: boolean;
    action?: object;
    deletable?: boolean;
    hasToggle?: boolean;
    itemIndex?: number;
    mappedTo?: string;
    format?: string;
    values?: string;
    value: string[] | object[] | Attachment[];
    styles?: object;
    boxStyle?: object;
    url?: UrlType;
    backgroundImage?: string;
    isDetail?: boolean;
};
export type TweetItem = {
    url: BlockElementText;
    id?: string;
};

export type GalleryItem = {
    image: {
        src: string;
        alt: string;
        className?: string | undefined;
        styles: any;
    };
};

export enum BlockEvents {
    UPDATE_RECORD_SUCCESS = "UPDATE_RECORD_SUCCESS",
    UPDATE_LINKED_BLOCK = "UPDATE_LINKED_BLOCK",
    UPDATE_DATASOURCE = "UPDATE_DATASOURCE",
}
export type FixedDateAndTimeFormatSettings = {
    type: "FIXED";
    fixedSettings: {
        dateFormat: "FRIENDLY" | "MM-DD-YYYY" | "DD-MM-YYYY" | "YYYY-MM-DD";
        dateFormatSeparator?: "-" | "/" | "." | null;
        timeFormat: "12" | "24";
        weekStart: 1 | 6 | 7;
    };
};

export type LocalDateAndTimeFormatSettings = {
    type: "LOCAL";
    localSettings: {
        localizeDayAndMonth: boolean;
    };
};
export interface ApplicationContext {
    policies: {
        numberOfDatasourceRecordsPerTable: number;
    };
    date_and_time_settings?: {
        formatSettings: FixedDateAndTimeFormatSettings | LocalDateAndTimeFormatSettings;
        timezoneSettings: {
            fixedTimezone: string | null;
            type: "FIXED" | "LOCAL";
        };
    };
    /**
     * Auth settings exposed from the platform only in user accounts utility pages
     */
    user_auth_settings?: UserAuthenticationSettings;
    /**
     * Datasource integration info exposed from the platform only in user accounts utility pages
     */
    datasource?: {
        id: string;
        type: DataSourceType;
        attributes: {
            emailFieldName: string;
            nameFieldName: string;
            profilePictureFieldName: string;
        };
    } | null;
}
// Auth settings exposed from the platform to the user account blocks via window
// still WIP, other parts will be added as we go
// also, we need to revisit this part before the release to exclude parts that won't be exposed by the platform
type UserAuthenticationSettings = {
    loginEnabled: boolean;
    authenticationMethods: ReadonlyArray<"EMAIL" | "SSO" | "GOOGLE">;
    emailAuthSettings: {
        loginMethods: ReadonlyArray<"PASSWORD" | "EMAIL_CODE">;
        passwordSettings: {
            inputLabel: string;
            inputPlaceholder: string;
            forgotPasswordText: string;
            incorrectPasswordText: string;
            newPasswordLabel: string;
            newPasswordPlaceholder: string;
            strongPasswords: boolean;
            minimumCharactersText: string;
            upperAndLowerCaseText: string;
            numberText: string;
            symbolText: string;
            repeatPasswordLabel: string;
            repeatPasswordPlaceholder: string;
            passwordsDontMatchText: string;
        };
        emailOneTimeCodeSettings: {
            expiration: "1" | "2" | "5" | "10" | "30";
            inputLabel: string;
            inputPlaceholder: string;
            resendText: string;
            invalidCodeText: string;
        };
        secondaryLoginMethods: ReadonlyArray<"EMAIL_CODE" | "SMS" | "AUTHENTICATOR">;
        inputLabel: string;
        inputPlaceholder: string;
    };
    googleSettings: {
        clientId: string;
        clientSecret: string;
        emailDomains: string[];
        userType: "INTERNAL" | "EXTERNAL";
    };
    ssoSettings: {
        type: string;
        emailDomains: string[];
        saml: {
            acsUrl: string;
            audienceUrl: string;
            metadataXml: string;
            emailKey: string;
            firstNameKey: string;
            lastNameKey: string;
        };
        openId: {
            callbackUrl: string;
            providerUrl: string;
            clientId: string;
            clientSecret: string;
        };
    };
};
declare global {
    interface Window {
        application_context?: ApplicationContext;
    }
}
